/**
 * Canonical experience-mode keys, shared between backend (validation of the
 * stored `user.experience_mode`) and frontend (the picker / layout switch).
 *
 * One DB column (`user.experience_mode`) stores the user's personal preference.
 * `null` / unknown values fall back to {@link DEFAULT_EXPERIENCE_MODE}.
 */

export const EXPERIENCE_MODES = ["full", "lite"] as const;

export type TExperienceMode = (typeof EXPERIENCE_MODES)[number];

export const DEFAULT_EXPERIENCE_MODE: TExperienceMode = "full";

export function isExperienceMode(value: unknown): value is TExperienceMode {
	return typeof value === "string" && (EXPERIENCE_MODES as readonly string[]).includes(value);
}
